import { userLogin, userRegister, getProfile, editProfile, postOutputRequest, userRestore } from '@/api'
//
export default {
	namespaced: true,

	state: {
		token: false,
		login: false,
		profile: false
	},

	mutations: {
		set (state, data) {
			state.token = data.token
			state.login = data.login
		},

		setProfile (state, profile) {
			if (profile.balance_list && Array.isArray(profile.balance_list)) {
				profile.balance_list.forEach(balanceItem => {
					if (balanceItem.linkedTransactions && balanceItem.linkedTransactions.length) {
						balanceItem.transactionDate = (new Date(balanceItem.linkedTransactions[0].date)).toLocaleString('ru-RU');
					} else {
						balanceItem.transactionDate = '-';
					}

					delete balanceItem.linkedTransactions;
				});
			}

			state.profile = profile
		}
	},

	actions: {
		userLogin (store, body) {
			return userLogin(body)
				.then(response => {
					if (!response || response.status !== 200) {
						return Promise.reject(response)
					}
					//
					store.commit('set', response.data.result)
					//
					localStorage.setItem('Auth', JSON.stringify(response.data.result))
					//
					return response
				})
		},

		userRegister (store, body) {
			return userRegister(body)
				.then(response => {
					if (!response || response.status !== 200) {
						return Promise.reject(response)
					}
					//
					store.commit('set', response.data.result)
					//
					localStorage.setItem('Auth', JSON.stringify(response.data.result))
					//
					return response
				})
		},

		getProfile (store) {
			return getProfile(store.state.token)
				.then(response => {
					store.commit('setProfile', response.data.result)
					//
					return response
				})
		},

		userRestore(store, body){
			return userRestore(body)
				.then(response => {
					return response
				})
		},

		editProfile (store, body) {
			return editProfile(store.state.token, body)
				.then(response => {
					store.commit('setProfile', response.data.result)
					//
					return response
				})
		},

		postOutputRequest (store, body) {
			return postOutputRequest(store.state.token, body)
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js